import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingCart, Truck, Gift, Award, ArrowLeft } from "lucide-react";

const NAV = [
    { to: "/admin/pos",            label: "Penjualan",  icon: ShoppingCart, testid: "posnav-sales" },
    { to: "/admin/pos/purchase",   label: "Pembelian",  icon: Truck,        testid: "posnav-purchase" },
    { to: "/admin/pos/rewards",    label: "Rewards",    icon: Gift,         testid: "posnav-rewards" },
    { to: "/admin/pos/commission", label: "Komisi",     icon: Award,        testid: "posnav-commission" },
];

export default function PosNav({ title, subtitle, right }) {
    const { pathname } = useLocation();
    return (
        <div className="mb-6">
            <div className="flex items-center justify-between gap-3 flex-wrap mb-3">
                <div>
                    <Link to="/admin" data-testid="posnav-back" className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground">
                        <ArrowLeft size={12} /> Kembali ke Admin
                    </Link>
                    <h1 className="mt-1 text-2xl sm:text-3xl font-bold tracking-tight">{title}</h1>
                    {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
                </div>
                {right}
            </div>
            <div className="flex flex-wrap items-center gap-2 border-b border-border pb-2">
                {NAV.map((n) => {
                    const active = pathname === n.to;
                    const Icon = n.icon;
                    return (
                        <Link key={n.to} to={n.to} data-testid={n.testid}
                            className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-xs font-medium border transition-colors ${active ? "bg-primary text-primary-foreground border-primary" : "bg-white border-border hover:bg-secondary"}`}>
                            <Icon size={13} /> {n.label}
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
